import { createApp } from 'vue'
export * from './components';
export * from './store/modules/headerfooter';
import App from './App.vue'
import store from './store'
import 'bootstrap/dist/js/bootstrap.js';
import "./assets/styles/custom.scss";
import 'bootstrap/dist/css/bootstrap.min.css';

createApp(App).use(store).mount('#app')
